import Vue from 'vue'

const loadComp = component => () => import(`@/components/${component}`)

Vue.component('app-layout-sider', loadComp('sider.vue'))